function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import { VCombobox, VListItemAction, VListItemContent, VListItemTitle, VSimpleCheckbox } from 'vuetify/lib';
import FormMixin from '../form.mixin';
import SelectSearchSortMixin from '../../../../assets/scripts/mixins/select-search-sort.mixin';

var Autocomplete = /*#__PURE__*/function () {
  function Autocomplete() {
    _classCallCheck(this, Autocomplete);
  }

  _createClass(Autocomplete, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-autocomplete', {
        template: "<v-combobox\n        class=\"roche-autocomplete\"\n        ref=\"combobox\"\n        item-text=\"label\"\n        item-value=\"value\"\n        hide-no-data\n        v-bind=\"bind\"\n        :rules=\"rules\"\n        :items=\"sortedItems\"\n        v-on=\"$listeners\"\n        :menu-props=\"menuProps\"\n        @update:search-input=\"handleSearchInput\"\n        @keyup.native.enter=\"validate\"\n        @change=\"onChange\"\n        persistent-placeholder\n        >\n        <template #item=\"slot\" v-if=\"description\">\n          <v-list-item-action color=\"primary\">\n            <v-simple-checkbox :ripple=\"false\" v-on=\"slot.on\"></v-simple-checkbox>\n          </v-list-item-action>\n          <v-list-item-content>\n            <div class=\"v-list-item__title autocomplete-title\" v-html=\"markedLabel(slot.item.label)\"></div>\n            <p class=\"autocomplete-description\" v-text=\"slot.item.description\" />\n          </v-list-item-content>\n        </template>\n        <template v-slot:append-outer v-if=\"bind.multiple\">\n          <span v-if=\"value && value.length\" class='counter counter-blue'>\n            <span class='counter-value'>\n              {{value.length}}\n            </span>\n          </span>\n        </template>\n        </v-combobox>",
        mixins: [FormMixin, SelectSearchSortMixin],
        props: {
          description: {
            type: Boolean,
            "default": false
          },
          showDropdown: {
            type: Boolean,
            "default": false
          },
          items: {
            type: Array,
            "default": function _default() {
              return [];
            }
          }
        },
        data: function data() {
          return {
            originalItems: this.items
          };
        },
        components: {
          VCombobox: VCombobox,
          VListItemAction: VListItemAction,
          VListItemContent: VListItemContent,
          VListItemTitle: VListItemTitle,
          VSimpleCheckbox: VSimpleCheckbox
        },
        computed: {
          menuProps: function menuProps() {
            return {
              offsetY: true,
              offsetOverflow: true,
              closeOnContentClick: this.closeOnContentClick
            };
          },
          closeOnContentClick: function closeOnContentClick() {
            if (this.bind.multiple) {
              return false;
            }

            return true;
          }
        },
        methods: {
          onChange: function onChange($e) {
            var _this = this;

            this.$nextTick(function () {
              if (_this.$refs.combobox.selectedItem && !_this.bind.multiple) {
                _this.$emit('input', _this.$refs.combobox.selectedItem);

                _this.$refs.combobox.blur();
              } else if (!$e) {
                _this.$emit('input', _this.bind.multiple ? _this.value || [] : _this.searchInput || '');

                _this.$refs.combobox.blur();
              } else if (_this.bind.multiple) {
                _this.sortAlphabetically(_this.sortedItems);

                var menuContent = _this.$refs.combobox.$refs.menu.$refs.content;

                if (menuContent) {
                  menuContent.scrollTop = 0;
                }

                _this.$emit('input', $e.filter(function (value) {
                  return !!value.value;
                }));
              }
            });
          },
          validate: function validate() {
            this.onChange();
            if (this.$refs.combobox.isMenuActive) this.$refs.combobox.blur();
          },
          markedLabel: function markedLabel(label) {
            if (this.searchInput) {
              // find the first occurrence of the search input in the label
              var index = label.toLowerCase().indexOf(this.searchInput.toLowerCase()); // store the properly cased version of the search result

              var originalCaseSearchResult = label.substring(index, index + this.searchInput.length); // if found, mark the label

              if (index !== -1) {
                label = "".concat(label.substring(0, index), "<span class=\"v-list-item__mask\">").concat(originalCaseSearchResult, "</span>").concat(label.substring(index + this.searchInput.length));
              }
            }

            return "<span>".concat(label, "</span>");
          }
        }
      });
    }
  }]);

  return Autocomplete;
}();

export default Autocomplete;